/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { keysToSnake } from '@/utils';
import { shouldSendTrace, handlePath } from './path_handlers';
import { getRequest } from '../../../../utils/client/client';

// Get URL from site config once this is moved inside SPA
const ENDPOINT_URL = '/sor_setup/trace_log';

export default async () => {
  let rawPath = window.location.pathname;
  if (!shouldSendTrace(rawPath)) {
    return;
  }
  const path = btoa(handlePath(rawPath));
  const traceStart = Number(document.body.dataset.requestStartTime);
  const elapsed = Date.now() - traceStart;
  const params = keysToSnake({path, elapsed});

  try {
    await getRequest({
      url: ENDPOINT_URL,
      params
    });
    console.log(`Successfully reported page load for ${rawPath}`);
  } catch(e) {
    console.error('Reporting page load failed.');
  }
};
